<template>
  <div class="dashboard">
    <LmsDashboard v-if="gconf.ui.home_setting == 'LMS'"/>
    <Dashboard v-else-if="gconf.ui.home_setting == 'Dashboard'"/>
    <div class="inner-wrap">

    </div>
  </div>
</template>

<script>
import Dashboard from "@/components/modules/dashboard/Dashboardv2";
import LmsDashboard from "@/views/custom/LMSDashboard";

export default {
  name: 'Home',
  components: {
    Dashboard,
    LmsDashboard
  },
  beforeMount() {
    this.gconf = window.gconf;
    if(this.gconf.ui.home_setting == "CpList") {
      this.$router.push("/cps");
    }
  },
  data() {
    return {
      gconf: {}
    }
  }
}
</script>

<style lang="scss">
.dashboard{
  // background: #eff3fa;
  & > .inner-wrap{
    & > .block {
      // flex: auto;
      height: 270px;
      min-width: 150px;
    }
  }
}
</style>